const category = [{
    id: 'c1',
    width: '8%',
    cont: '번호'
},{
    id: 'c2',
    width: '11%',
    cont: '글 종류'
},{
    id: 'c3',
    width: '32%',
    cont: '제목'
},{
    id: 'c4',
    width: '10%',
    cont: '작성자'
},{
    id: 'c5',
    width: '16%',
    cont: '날짜'
},{
    id: 'c6',
    width: '15%',
    cont: '진행도'
}];

export default category;